export default function defaultColumn({cachedColumn, rowData}) {
    /* eslint-disable no-console */
    console.warn(`Default column type was used for ${cachedColumn.header}!`, cachedColumn);
    return [
        'span',
        rowData.fields[cachedColumn.field],
    ];
}
